import axios from "axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { ProfileForm } from "../types/Forms";

const fetchProfileForms =
  (authHeader: string, profileId: string | number) => async () => {
    const res = await axios.get<ProfileForm[]>(
      `${env.verifyServiceUrl}individual/profile/${profileId}/forms/`,
      { headers: { Authorization: authHeader } , skipGlobalErrorHandler: true, }
    );
    return res.data;
  };

export const useProfileForms = (profileId?: string | number) => {
  const { authHeader } = useAuth();

  return useQuery({
    queryKey: ["profileForms", profileId],
    queryFn: fetchProfileForms(authHeader, profileId as string | number),
    enabled: !!profileId,
    retry: false,
    // onError: (err: any) => {
    //   const status = err?.request?.status ?? err?.response?.status;
    //   // if (status === 500 || status === 503) navigate(ROUTE.SERVER_ERROR);
    //   // else 
    //     if (status === 401) navigate(ROUTE.LOGOUT);
    // },
  });
};
